import { AppBar, Box, Button, Checkbox, debounce, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, TextField, Toolbar, Typography } from "@mui/material"
import { useAppSelector } from "../../../../../../hooks/store-hooks"
import { useLayoutExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Transition } from "../../../../../../components"
import { useEffect, useState } from "react"
import { velesGeoColunasPadraoExtracao } from "../../../../../../assets/helpers/velesGeoColunasPadraoExtracao"
import { IColunaExtracao, IPessoaFisica } from "../../../../../../../application/models"
import { Reorder } from "framer-motion"
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'
import EditIcon from '@mui/icons-material/Edit'
import SearchIcon from '@mui/icons-material/Search'
import { useUIService } from "../../../../../../../use-cases/ui"

export const CreateLayoutForm = () => {
    // State
    const { createLayoutFormOpen, createLayoutForm: { fields, touched, errors } } = useAppSelector((state) => state.layoutExtracao)
    // Use State
    const [loading, setLoading] = useState<boolean>(true)
    const [colunasDisponiveisSearchTerm, setColunasDisponiveisSearchTerm] = useState<string>('')
    const [colunasSelecionadasSearchTerm, setColunasSelecionadasSearchTerm] = useState<string>('')
    const [colunasFormChecked, setColunasFormChecked] = useState<any[]>([])
    const [colunasPadraoChecked, setColunasPadraoChecked] = useState<any[]>([])
    const [openEditColumn, setOpenEditColumn] = useState<boolean>(false)
    const [selectedColumnToEdit, setSelectedColumnToEdit] = useState<IColunaExtracao>({
        label: '',
        value: 'random'
    })
    // Service
    const {
        setCreateLayoutFormOpen,
        createLayout,
        setCreateLayoutFormFieldsNome,
        setCreateLayoutFormFieldsColunas,
        resetCreateLayoutForm
    } = useLayoutExtracaoService()
    const { changeTitleAndMetaDesc } = useUIService()
    // UseEffect
    useEffect(() => {
        setLoading(false)
    }, [])

    useEffect(() => {
        changeTitleAndMetaDesc({
            metaDesc: 'Criação de layout para download de arquivos',
            title: 'Veles_Geo - Criar layout'
        })
    }, [changeTitleAndMetaDesc])
    // Functions
    const closeCreateLayout = () => {
        setCreateLayoutFormOpen(false)
        resetCreateLayoutForm()
        setColunasPadraoChecked([])
        setColunasFormChecked([])
        setColunasDisponiveisSearchTerm('')
        setColunasSelecionadasSearchTerm('')
    }
    const closeEditColumn = () => {
        setOpenEditColumn(false)
        setSelectedColumnToEdit({
            label: '',
            value: 'random'
        })
    }
    const handleToggleForm = (value: keyof IPessoaFisica) => () => {
        const currentIndex = colunasFormChecked.indexOf(value);
        const newChecked = [...colunasFormChecked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setColunasFormChecked(newChecked);
    };
    const handleTogglePadrao = (value: keyof IPessoaFisica) => () => {
        const currentIndex = colunasPadraoChecked.indexOf(value);
        const newChecked = [...colunasPadraoChecked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setColunasPadraoChecked(newChecked);
    };

    return (
        <>
            {
                loading ? <></>
                    : (<>
                        <Dialog
                            open={createLayoutFormOpen}
                            onClose={closeCreateLayout}
                            TransitionComponent={Transition}
                            fullScreen
                            disableEscapeKeyDown
                        >
                            <AppBar sx={{ position: 'relative' }}>
                                <Toolbar>
                                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div" textTransform={"uppercase"}>
                                        Criar layout
                                    </Typography>
                                    <Button
                                        autoFocus
                                        color="inherit"
                                        onClick={closeCreateLayout}
                                    >
                                        Fechar
                                    </Button>

                                </Toolbar>
                            </AppBar>
                            <DialogContent dividers>
                                <DialogContentText my={2}>
                                    Neste formulário, você deve inserir um nome para seu layout, e as colunas que farão parte dele.
                                </DialogContentText>
                                <DialogContentText my={2}>
                                    Para escolher as colunas que farão parte do seu arquivo, basta selecionar os itens disponíveis na coluna <strong>à esquerda</strong>,
                                    e clicar no botão centralizado com ícone semelhante a "&gt;".
                                    <br />
                                    Para remover colunas do seu layout, basta fazer o mesmo processo, mas com a coluna da direita, descrita como <strong>COLUNAS SELECIONADAS</strong>.
                                    <br />
                                    <br />
                                    Em "editar", é possível alterar o nome em que cada coluna será chamada no seu arquivo.
                                </DialogContentText>
                                <Grid
                                    container
                                    gap={2}
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    my={3}
                                >
                                    <Grid item xs={12} py={2}>
                                        <TextField
                                            defaultValue={fields.Nome}
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            onChange={debounce((e) => {
                                                setCreateLayoutFormFieldsNome(e.target.value)
                                            }, 300)}
                                            error={Boolean(touched && errors.find(item => item.key === 'Nome'))}
                                            helperText={errors.find(item => item.key === 'Nome')?.message}
                                            name="nome"
                                            fullWidth
                                            id="nome"
                                            label="Nome do Layout"
                                        />
                                    </Grid>
                                    <Grid container spacing={2} justifyContent="center">
                                        <Grid item xs={5} justifyContent="center" direction={'column'}>
                                            <Grid item xs={12} my={1}>
                                                <Typography
                                                    variant="body1"
                                                    color="primary"
                                                    fontWeight={'bold'}
                                                    textTransform={'uppercase'}
                                                    textAlign={'center'}
                                                >
                                                    Colunas disponíveis para selecionar
                                                </Typography>
                                            </Grid>
                                            <List dense component="div" role="list" sx={{ maxHeight: 250, overflowY: 'auto' }}>
                                                <ListItem>
                                                    <TextField
                                                        fullWidth
                                                        label="Digite o nome da coluna"
                                                        variant="standard"
                                                        InputProps={{
                                                            endAdornment: <SearchIcon />
                                                        }}
                                                        onChange={debounce((e) => {
                                                            setColunasDisponiveisSearchTerm(e.target.value)
                                                        }, 200)}
                                                    />
                                                </ListItem>
                                                {velesGeoColunasPadraoExtracao.filter(
                                                    (item) => !fields.Colunas.find((coluna) => coluna.value === item.value)
                                                ).filter((item) => {
                                                    if (colunasDisponiveisSearchTerm.length <= 1) return true
                                                    return item.label.toLocaleLowerCase().includes(colunasDisponiveisSearchTerm.toLocaleLowerCase()) || item.value.toLocaleLowerCase().includes(colunasDisponiveisSearchTerm.toLocaleLowerCase())
                                                }).map((item) => {
                                                    const labelId = `transfer-list-item-${item.value}-label`;

                                                    return (
                                                        <ListItemButton
                                                            key={item.value}
                                                            role="listitem"
                                                            onClick={handleTogglePadrao(item.value)}
                                                        >
                                                            <ListItemIcon>
                                                                <Checkbox
                                                                    checked={colunasPadraoChecked.indexOf(item.value) !== -1}
                                                                    tabIndex={-1}
                                                                    disableRipple
                                                                    inputProps={{
                                                                        'aria-labelledby': labelId,
                                                                    }}
                                                                />
                                                            </ListItemIcon>
                                                            <ListItemText id={labelId} primary={`${item.label}`} />
                                                        </ListItemButton>
                                                    );
                                                })}
                                            </List>
                                        </Grid>
                                        <Grid item xs={2} container direction="column" justifyContent="center">
                                            <Button
                                                disabled={velesGeoColunasPadraoExtracao.filter(
                                                    (item) => !fields.Colunas.find((coluna) => coluna.value === item.value)
                                                ).length === 0 || colunasPadraoChecked.length === 0}
                                                sx={{ my: 0.5 }}
                                                variant="outlined"
                                                size="small"
                                                aria-label="move selected right"
                                                onClick={() => {
                                                    setCreateLayoutFormFieldsColunas([
                                                        ...fields.Colunas,
                                                        ...velesGeoColunasPadraoExtracao.filter((item) => colunasPadraoChecked.includes(item.value))
                                                    ])
                                                    setColunasPadraoChecked([])
                                                }}
                                            >
                                                <KeyboardArrowRightIcon />
                                            </Button>
                                            <Button
                                                disabled={colunasFormChecked.length === 0}
                                                sx={{ my: 0.5 }}
                                                variant="outlined"
                                                size="small"
                                                aria-label="move selected left"
                                                onClick={() => {
                                                    setCreateLayoutFormFieldsColunas(fields.Colunas.filter((coluna) => !colunasFormChecked.includes(coluna.value)))
                                                    setColunasFormChecked([])
                                                }}
                                            >
                                                <KeyboardArrowLeftIcon />
                                            </Button>
                                        </Grid>
                                        <Grid item xs={5} justifyContent="center" direction={'column'}>
                                            <Grid item xs={12} my={1}>
                                                <Typography
                                                    variant="body1"
                                                    color="primary"
                                                    fontWeight={'bold'}
                                                    textTransform={'uppercase'}
                                                    textAlign={'center'}
                                                >
                                                    Colunas selecionadas
                                                </Typography>
                                            </Grid>
                                            <List dense component="div" role="list" sx={{ maxHeight: 250, overflowY: 'auto' }}>
                                                <ListItem>
                                                    <TextField
                                                        fullWidth
                                                        label="Digite o nome da coluna"
                                                        variant="standard"
                                                        InputProps={{
                                                            endAdornment: <SearchIcon />
                                                        }}
                                                        onChange={debounce((e) => {
                                                            setColunasSelecionadasSearchTerm(e.target.value)
                                                        }, 200)}
                                                    />
                                                </ListItem>
                                                <Reorder.Group
                                                    style={{
                                                        listStyle: 'none',
                                                        margin: 0,
                                                        padding: 0,
                                                        alignItems: 'start',
                                                    }}
                                                    axis="y"
                                                    values={fields.Colunas}
                                                    onReorder={(newOrder) => setCreateLayoutFormFieldsColunas(newOrder)}
                                                >
                                                    {fields.Colunas.filter((item) => {
                                                        if (colunasSelecionadasSearchTerm.length <= 1) return true
                                                        return (
                                                            item.label.toLocaleLowerCase().includes(colunasSelecionadasSearchTerm.toLocaleLowerCase())
                                                            || item.value.toLocaleLowerCase().includes(colunasSelecionadasSearchTerm.toLocaleLowerCase())
                                                        )
                                                    }).map((item) => (
                                                        <Reorder.Item
                                                            key={item.value}
                                                            value={item}
                                                        >
                                                            <ListItem
                                                                secondaryAction={
                                                                    <Button
                                                                        endIcon={<EditIcon />}
                                                                        style={{
                                                                            paddingRight: 5
                                                                        }}
                                                                        onClick={() => {
                                                                            setOpenEditColumn(true)
                                                                            setSelectedColumnToEdit(item)
                                                                        }}
                                                                    >
                                                                        Editar
                                                                    </Button>
                                                                }
                                                            >
                                                                <ListItemButton key={item.value} role="listitem">
                                                                    <ListItemIcon>
                                                                        <Checkbox
                                                                            checked={colunasFormChecked.indexOf(item.value) !== -1}
                                                                            tabIndex={-1}
                                                                            onClick={handleToggleForm(item.value)}
                                                                            disableRipple
                                                                        />
                                                                    </ListItemIcon>
                                                                    <ListItemText id={item.value} primary={`${item.label}`} />
                                                                </ListItemButton>
                                                            </ListItem>
                                                        </Reorder.Item>
                                                    ))}
                                                </Reorder.Group>
                                            </List>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    autoFocus
                                    onClick={() => createLayout()}
                                    disabled={fields.Colunas.length === 0 || fields.Nome.length === 0}
                                    variant="contained"

                                >
                                    Criar layout
                                </Button>
                            </DialogActions>
                        </Dialog>
                        {/* Editar coluna */}
                        <Dialog
                            open={openEditColumn}
                            onClose={closeEditColumn}
                            disableEscapeKeyDown
                        >
                            <DialogTitle>Edição de coluna</DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    Escolha um novo título para a coluna
                                </DialogContentText>
                                <Box mt={3}>
                                    <TextField
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                        defaultValue={selectedColumnToEdit.label}
                                        autoFocus
                                        margin="dense"
                                        id="name"
                                        label="Digite o nome da coluna"
                                        type="text"
                                        fullWidth
                                        variant="standard"
                                        onChange={debounce((e) => {
                                            setSelectedColumnToEdit({
                                                ...selectedColumnToEdit,
                                                label: e.target.value
                                            })
                                        }, 400)}
                                    />
                                </Box>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    onClick={closeEditColumn}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    onClick={() => {
                                        setCreateLayoutFormFieldsColunas(fields.Colunas.map((column) => {
                                            if (column.value === selectedColumnToEdit.value) {
                                                return {
                                                    ...column,
                                                    label: selectedColumnToEdit.label
                                                }
                                            }
                                            return column
                                        })
                                        )
                                        closeEditColumn()
                                    }}
                                >
                                    Ok
                                </Button>

                            </DialogActions>
                        </Dialog>
                    </>)
            }
        </>
    )
}